/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sidebar_DashboardInputs */

const en_admin_sidebar_dashboard = /** @type {(inputs: Admin_Sidebar_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const de_admin_sidebar_dashboard = /** @type {(inputs: Admin_Sidebar_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Admin_Sidebar_DashboardInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_sidebar_dashboard = /** @type {((inputs?: Admin_Sidebar_DashboardInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sidebar_DashboardInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_sidebar_dashboard(inputs)
	return en_admin_sidebar_dashboard(inputs)
});